import { render, staticRenderFns } from "./dashboard-sanea-dso.vue?vue&type=template&id=b97cd34a&scoped=true"
import script from "./dashboard-sanea-dso.vue?vue&type=script&lang=js"
export * from "./dashboard-sanea-dso.vue?vue&type=script&lang=js"
import style0 from "./dashboard-sanea-dso.vue?vue&type=style&index=0&id=b97cd34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97cd34a",
  null
  
)

export default component.exports